class EventFormSync {
  constructor() {
    this.eventLists = {
      form_single: this.getSingleFormEventList(),
      form_group_internal: ["idEventsDates-Gruppen"],
      form_group_external: ["idEventsDates-Gruppen"],
    };

    this.init();
  }

  init() {
    this.populateInitialDates();
    this.setupEventListeners();
  }

  getSingleFormEventList() {
    const form = document.getElementById("form_single");
    if (!form) return ["idEventsDatesEinzelDE"];

    const languageSwitch = form.querySelector(
      '.widget_language_switch input[type="radio"]:checked',
    );
    if (languageSwitch && languageSwitch.value === "englisch") {
      return ["idEventsDatesEinzelEN"];
    }
    return ["idEventsDatesEinzelDE"];
  }

  getEventsFromLists(listIds) {
    const events = [];
    listIds.forEach((listId) => {
      const list = document.getElementById(listId);
      if (list) {
        const eventElements = list.querySelectorAll(".event");
        eventElements.forEach((event) => {
          const date = event.getAttribute("data-date");
          const time = event.getAttribute("data-time");
          if (date && time) {
            events.push({ date, time });
          }
        });
      }
    });
    return events;
  }

  getUniqueValues(events, key) {
    const values = events.map((event) => event[key]).filter(Boolean);
    const unique = [...new Set(values)];

    if (key === "date") {
      unique.sort((a, b) => {
        const parseDate = (str) => {
          const match = str.match(/(\d{2})\.(\d{2})\.(\d{2,4})/);
          if (!match) return 0;
          const [, day, month, year] = match;
          const fullYear =
            year.length === 2 ? 2000 + parseInt(year) : parseInt(year);
          return new Date(
            fullYear,
            parseInt(month) - 1,
            parseInt(day),
          ).getTime();
        };
        return parseDate(a) - parseDate(b);
      });
    } else {
      unique.sort();
    }

    return unique;
  }

  populateMenu(menuElement, items) {
    const list = menuElement.querySelector(".mdc-deprecated-list");
    if (!list) return;

    list.innerHTML = "";

    items.forEach((item) => {
      const li = document.createElement("li");
      li.className = "mdc-deprecated-list-item";
      li.setAttribute("role", "menuitem");
      li.setAttribute("data-value", item);

      li.innerHTML = `
                <span class="mdc-deprecated-list-item__ripple"></span>
                <span class="mdc-deprecated-list-item__text">${item}</span>
            `;

      li.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleMenuSelection(menuElement, item);
      });

      list.appendChild(li);
    });
  }

  handleMenuSelection(menuElement, value) {
    const widget = menuElement.closest(
      ".widget-text--eventdate, .widget-text--eventtime",
    );
    if (!widget) return;

    const textField = widget.querySelector(".mdc-text-field__input");
    if (textField) {
      textField.value = value;
      textField.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (widget.classList.contains("widget-text--eventdate")) {
      this.updateTimeMenuForDate(value, widget);
    }

    if (menuElement.MDCMenu) {
      menuElement.MDCMenu.open = false;
    }
  }

  updateTimeMenuForDate(selectedDate, dateWidget) {
    const form = dateWidget.closest("form");
    if (!form) return;

    const timeWidget = form.querySelector(".widget-text--eventtime");
    if (!timeWidget) return;

    const timeMenu = timeWidget.querySelector(".mdc-menu");
    const timeInput = timeWidget.querySelector(".mdc-text-field__input");

    const formId = form.id;
    let eventListIds = this.eventLists[formId];
    if (formId === "form_single") {
      eventListIds = this.getSingleFormEventList();
    }
    if (!eventListIds) return;

    const events = this.getEventsFromLists(eventListIds);
    const timesForDate = events
      .filter((event) => event.date === selectedDate)
      .map((event) => event.time)
      .filter(Boolean);

    const uniqueTimes = [...new Set(timesForDate)].sort();

    if (timeMenu) {
      this.populateMenu(timeMenu, uniqueTimes);
    }

    // Only clear time if it's not valid for the selected date
    if (timeInput) {
      const currentTimeValue = timeInput.value.trim();
      if (currentTimeValue && !uniqueTimes.includes(currentTimeValue)) {
        timeInput.value = "";

        // Notify MDC text field about the value change to reset visual state
        const mdcTextField = timeWidget.querySelector(".mdc-text-field");
        if (mdcTextField && mdcTextField.MDCTextField) {
          mdcTextField.MDCTextField.value = "";
        }
      }
    }

    // Enable/disable the time widget based on available options
    this.toggleTimeWidget(timeWidget, uniqueTimes.length > 0);
  }

  toggleTimeWidget(timeWidget, enabled) {
    const timeInput = timeWidget.querySelector(".mdc-text-field__input");
    const mdcTextField = timeWidget.querySelector(".mdc-text-field");
    const trailingIcon = timeWidget.querySelector(
      ".mdc-text-field__icon--trailing",
    );

    if (timeInput) {
      timeInput.disabled = !enabled;
    }

    if (mdcTextField) {
      if (enabled) {
        mdcTextField.classList.remove("mdc-text-field--disabled");
      } else {
        mdcTextField.classList.add("mdc-text-field--disabled");
      }
    }

    if (trailingIcon) {
      if (enabled) {
        trailingIcon.style.pointerEvents = "auto";
        trailingIcon.style.opacity = "1";
      } else {
        trailingIcon.style.pointerEvents = "none";
        trailingIcon.style.opacity = "0.3";
      }
    }
  }

  toggleDateWidget(dateWidget, enabled, formId = "") {
    const dateInput = dateWidget.querySelector(".mdc-text-field__input");
    const mdcTextField = dateWidget.querySelector(".mdc-text-field");
    const trailingIcon = dateWidget.querySelector(
      ".mdc-text-field__icon--trailing",
    );
    const label = dateWidget.querySelector(".mdc-floating-label");

    if (dateInput) {
      dateInput.disabled = !enabled;
    }

    if (mdcTextField) {
      if (enabled) {
        mdcTextField.classList.remove("mdc-text-field--disabled");
      } else {
        mdcTextField.classList.add("mdc-text-field--disabled");
      }
    }

    if (trailingIcon) {
      if (enabled) {
        trailingIcon.style.pointerEvents = "auto";
        trailingIcon.style.opacity = "1";
      } else {
        trailingIcon.style.pointerEvents = "none";
        trailingIcon.style.opacity = "0.3";
      }
    }

    if (label && !enabled) {
      this.updateLabelForEmptyEventList(label, formId);
    }
  }

  updateLabelForEmptyEventList(label, formId) {
    const htmlLang = document.documentElement.lang;
    let noEventsText = "Keine Termine verfügbar";

    if (htmlLang && htmlLang.toLowerCase().startsWith("en")) {
      noEventsText = "No dates available";
    }

    label.textContent = noEventsText;
  }

  populateInitialDates() {
    Object.keys(this.eventLists).forEach((formId) => {
      const form = document.getElementById(formId);
      if (!form) return;

      const dateWidget = form.querySelector(".widget-text--eventdate");
      if (!dateWidget) return;

      const dateMenu = dateWidget.querySelector(".mdc-menu");
      if (!dateMenu) return;

      let eventListIds = this.eventLists[formId];
      if (formId === "form_single") {
        eventListIds = this.getSingleFormEventList();
      }
      const events = this.getEventsFromLists(eventListIds);
      const uniqueDates = this.getUniqueValues(events, "date");

      if (uniqueDates.length === 0) {
        // No events available - disable date widget and update label
        this.toggleDateWidget(dateWidget, false, formId);
        const timeWidget = form.querySelector(".widget-text--eventtime");
        if (timeWidget) {
          this.toggleTimeWidget(timeWidget, false);
        }
        return;
      }

      // Events available - enable date widget and populate menu
      this.toggleDateWidget(dateWidget, true, formId);
      this.populateMenu(dateMenu, uniqueDates);

      // Check if date field already has a value
      const dateInput = dateWidget.querySelector(".mdc-text-field__input");
      const timeWidget = form.querySelector(".widget-text--eventtime");

      if (timeWidget) {
        if (dateInput && dateInput.value.trim()) {
          // If date is already selected, update time menu and keep it enabled
          this.updateTimeMenuForDate(dateInput.value.trim(), dateWidget);
        } else {
          // Only disable time widget if no date is selected
          this.toggleTimeWidget(timeWidget, false);
        }
      }
    });
  }

  setupEventListeners() {
    document
      .querySelectorAll(".widget-text--eventdate .mdc-text-field__input")
      .forEach((input) => {
        input.addEventListener("change", (e) => {
          const widget = e.target.closest(".widget-text--eventdate");
          if (widget) {
            this.updateTimeMenuForDate(e.target.value, widget);
          }
        });
      });

    // Add language switch listener for form_single
    const singleForm = document.getElementById("form_single");
    if (singleForm) {
      const languageRadios = singleForm.querySelectorAll(
        '.widget_language_switch input[type="radio"]',
      );
      languageRadios.forEach((radio) => {
        radio.addEventListener("change", () => {
          this.handleLanguageChange(singleForm);
        });
      });
    }

    document.addEventListener("click", (e) => {
      if (e.target.closest(".mdc-text-field__icon--trailing")) {
        const widget = e.target.closest(
          ".widget-text--eventdate, .widget-text--eventtime",
        );
        if (widget) {
          // Don't open menu if time widget is disabled
          if (widget.classList.contains("widget-text--eventtime")) {
            const textField = widget.querySelector(".mdc-text-field");
            if (
              textField &&
              textField.classList.contains("mdc-text-field--disabled")
            ) {
              return;
            }
          }

          const menu = widget.querySelector(".mdc-menu");
          if (menu && menu.MDCMenu) {
            menu.MDCMenu.open = !menu.MDCMenu.open;
          }
        }
      }
    });
  }

  handleLanguageChange(form) {
    // Clear date and time fields
    const dateWidget = form.querySelector(".widget-text--eventdate");
    const timeWidget = form.querySelector(".widget-text--eventtime");

    if (dateWidget) {
      const dateInput = dateWidget.querySelector(".mdc-text-field__input");
      const dateTextField = dateWidget.querySelector(".mdc-text-field");
      if (dateInput) {
        dateInput.value = "";
        if (dateTextField && dateTextField.MDCTextField) {
          dateTextField.MDCTextField.value = "";
        }
      }
    }

    if (timeWidget) {
      const timeInput = timeWidget.querySelector(".mdc-text-field__input");
      const timeTextField = timeWidget.querySelector(".mdc-text-field");
      if (timeInput) {
        timeInput.value = "";
        if (timeTextField && timeTextField.MDCTextField) {
          timeTextField.MDCTextField.value = "";
        }
      }
      // Disable time widget since no date is selected
      this.toggleTimeWidget(timeWidget, false);
    }

    // Refresh the date menu with new language
    const dateMenu = dateWidget.querySelector(".mdc-menu");
    if (dateMenu) {
      const eventListIds = this.getSingleFormEventList();
      const events = this.getEventsFromLists(eventListIds);
      const uniqueDates = this.getUniqueValues(events, "date");

      if (uniqueDates.length === 0) {
        // No events available - disable date widget and update label
        this.toggleDateWidget(dateWidget, false, "form_single");
      } else {
        // Events available - enable date widget and populate menu
        this.toggleDateWidget(dateWidget, true, "form_single");
        this.populateMenu(dateMenu, uniqueDates);
      }
    }
  }

  refresh() {
    this.populateInitialDates();
  }
}

let eventFormSync;

document.addEventListener("DOMContentLoaded", () => {
  eventFormSync = new EventFormSync();
});

document.addEventListener("ajax-form-changed", function () {
  console.log("event: ajax-form-changed from form.js");
  if (eventFormSync) {
    eventFormSync.refresh();
  }
});
